// extracted by mini-css-extract-plugin
export default {"page":"FeedbackPage_page__X4eP9"};